<template>
  <div class="page">
    <p :class="{blur : zoomOn}">
      Cette page vous montre les images des différents filtres de couleur de la mission 0. Les images de USNO-B1 sont montrés dans la file d’en haut et celles de PanSTARRs apparaissent dans celle d’en bas. Avec ces images vous pouvez explorer plus de détails de ce cas-ci et nous informer si vos découvertes sont consistantes a travers les différents filtres de couleur.
    </p>
    <p>
      Si vous êtes certain d’avoir découvert quelque chose de vraiment intéressant, n’oubliez pas de nous envoyer un commentaire qui inclue votre adresse de courrier électronique pour qu’on puisse vous contacter.
    </p>
    <div class="inspect-wrapper">
      <div :class="['dim', {visible : zoomOn}]" @click="closeZoom">
        <img class="zoomed" :src="zoomed">
      </div>
      <div :class="['inspect', {blur : zoomOn}]">
        <div v-for="(band, i) in usnoBands" class="pair usno" :key="`U${i}`">
          <h2> USNO {{ band }} </h2>
          <img :src="getUsnoImage(imageKey, i)" v-on:click="zoom" onerror="this.src='darth.png'">
        </div>
        <div v-for="(band, i) in panstarrsBands" class="pair panstarr" :key="`P${i}`">
          <img :src="getPanstarrsImage(imageKey, i)" @click="zoom" onerror="this.src='darth.png'">
          <h2> PanSTARR {{ band }} </h2>
        </div>
      </div>
    </div>
    <div class="padding"/>
    <div
      v-if="showComments"
      class="inspect__comments-container">
      <button
        class="button inspect__go-back-button"
        @click="onGoBack">
        RETOUR
      </button>
      <CommentList
        :isLoading="isLoadingComments"
        :comments="comments"/>
    </div>
    <div v-else>
      <CommentForm
        :placeholder="commentFormPlaceholder"
        :imageKey="imageKey"
        :isBlurred="this.zoomOn"
        :onSubmitted="this.handleSubmitted"/>
      <div class="padding"/>
    </div>
  </div>
</template>

<script>
import CommentList from '@/components/CommentList.vue'
import CommentForm from '@/components/CommentForm.vue'
import {DATASETS_BANDS} from '@/utils/dataset-bands'
import {REQUEST_STATUS} from '@/store/utils/request-status'
import {getUsnoImage} from '@/api/utils/usno-image'
import {getPanstarrsImage} from '@/api/utils/panstarrs-image'
import {mapState, mapActions} from 'vuex'

export default {
  name: 'inspect',
  components: {
    CommentList,
    CommentForm
  },
  data: function() {
    return {
      usnoBands: DATASETS_BANDS.map((x) => x.USNO),
      panstarrsBands: DATASETS_BANDS.map((x) => x.PanSTARR),
      zoomed: '',
      zoomOn: false,
      showComments: false
    }
  },
  computed: {
    ...mapState({
      isLoadingComments: ({comment}) => comment.status === REQUEST_STATUS.GET,
      comments: ({comment}) => Object.keys(comment.items).map((k) => comment.items[k])
    }),
    commentFormPlaceholder: function() {
      return 'Écrivez ce que vous pensez sur ce cas-ci. Voyez-vous des signes subtiles de quelque chose de bizarre dans cette mission-ci? Cliquez le bouton "Envoyer", et nous montreront vos commentaires aux autres personnes qui étudieront cette mission! Vous pouvez toujours revenir sur cette mission (numéro identificatif 0) en introduisant ce numéro dans le champ "mission" sur l’écran principal.'
    },
    imageKey: function() {
      return Number(this.$route.params.imageKey)
    }
  },
  methods: {
    ...mapActions([
      'fetchComments'
    ]),
    zoom: function (ev) {
      this.zoomed = ev.target.src
      this.zoomOn = true
    },
    closeZoom: function () {
      this.zoomOn = false
    },
    handleSubmitted: function() {
      this.showComments = true
      this.fetchComments(this.imageKey)
    },
    onGoBack: function(e) {
      e.preventDefault()
      window.close()
    },
    getUsnoImage: function (imageKey, band) {
      return getUsnoImage(imageKey, band)
    },
    getPanstarrsImage: function (imageKey, band) {
      return getPanstarrsImage(imageKey, band)
    }
  }
}
</script>
<style>
  .page {
    padding-top: 4em;
    min-height:100vh;
  }
  #nav-wrapper {
    display: none;
  }
  .inspect-wrapper {
    width:100vw;
    overflow: scroll;
    background: linear-gradient(to right, rgba(200,200,255,0.1), rgba(255,200,200,0.1));
  }
  .dim {
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    display: none;
    z-index: 2;
  }
  .blur {
    filter: blur(5px);
  }
  .visible {
    display: block;
  }
  .zoomed {
    display: block;
    margin: auto;
    width:500px;
    max-width: 100vw;
    margin-top: 10vh;
    border: 1px solid #342;
  }
  .inspect {
    margin: auto;
    font-family: 'Overpass Mono', monospace;
    width: calc(1000px + 5em);
  }
  .pair img {
    width: 100%;
    cursor: pointer;
  }
  .pair h2 {
    text-align: center;
    font-weight: normal;
    font-size: 16pt;
  }
  .pair {
    max-width:200px;
    width:50vw;
    display: inline-block;
    margin-right: 1em;
  }
  .usno {
    color: pink;
  }
  .panstarr {
    color: lightblue;
  }
  .inspect__comments-container {
    max-width: 768px;
    min-width: 320px;
    margin: 0px auto;
    text-align: left;
  }
  .inspect__go-back-button {
    display: block;
    margin: 0px auto;
  }
</style>
